import React, { Component } from 'react'
import { localize } from '../../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import classnames from 'classnames'
//
import Card from '@material-ui/core/Card'
import Paper from '@material-ui/core/Paper'
import Icon from '@material-ui/core/Icon'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
//
import { withStyles } from '@material-ui/core/styles'
import CardStyles from '../../styles/cards'

class ClaimReceipts extends Component {
  constructor (props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)

    this.state = {
      open: false,
      imgContent: null,
      imgType: null,
      imgName: null
    }
  }

  b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new window.Blob(byteArrays, { type: contentType })
    return blob
  }

  handleOpen (content, type, name) {
    this.setState({
      open: true,
      imgContent: content,
      imgType: type,
      imgName: name
    })
  }

  handleClose () {
    this.setState({ open: false })
  }

  render () {
    const claimLines = this.props.claimLines
    const fileType = /^(jpe?g|png|gif)$/
    const { classes = {} } = this.props
    return (
      <div>
        <h4 className='sectionHeading'>{localize('pages.claims.uploadedFiles')}</h4>

        <Card className={classnames(classes.summaryCard, classes.baseCard, classes.receiptContainer)}>
          {claimLines && claimLines.receipts.map((rec, key) => {
            const doc = `data:${rec.contentType};base64,${encodeURIComponent(rec.content)}`
            const rf = rec.fileExtension
            if (fileType.test(rf)) {
              return (
                <div key={key} className={classes.container}>
                  <Paper
                    className={`${classes.imgPaper} ${classes.imgPaperBackground}`}
                    style={{
                      backgroundImage: `url(${rec && rec.content ? `data:${rec.type};base64,${rec.content}` : null})`
                    }}
                    alt={rec.fileName}
                    onClick={() => this.handleOpen(rec.content, rec.type, rec.name)} />
                  <p className={classes.fileName}>{rec.fileName}</p>
                </div>
              )
            } else {
              let browser = navigator.userAgent
              let blob = this.b64toBlob(rec.content, rec.contentType)
              const FileSaver = require('file-saver')
              // check to see if user needs another way to download
              const IE = function () {
                if (browser.indexOf('MSIE ') > -1 || browser.indexOf('Trident/') > -1 || browser.indexOf('Edge') > -1) {
                  return true
                } else return false
              }
              return (
                <div key={key} className={classes.container}>
                  <a href={doc} download={rec.fileName} onClick={IE() ? () => { FileSaver.saveAs(blob, rec.fileName) } : null} className={classes.link}>{/**/}
                    <Paper
                      className={classes.imgPaper}
                      alt={rec.fileName}>
                      <Icon className={classes.icon} color='primary'>insert_drive_file</Icon>
                    </Paper></a>
                  <p className={classes.fileName}>{rec.fileName}</p>
                </div>
              )
            }
          })}
          <Dialog onClose={this.handleClose} open={this.state.open}>
            <DialogContent>
              {this.state.imgId !== null ? <img alt={this.state.imgName} src={`data:${this.state.imgType};base64,${this.state.imgContent}`} /> : null}
            </DialogContent>
          </Dialog>
        </Card>
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return {
    user: state.user
  }
}

const styles = {
  ...CardStyles,
  receiptContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  container: {
    width: 175
  },
  imgPaper: {
    height: 150,
    width: 150,
    margin: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  imgPaperBackground: {
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  fileName: {
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    padding: '0px 10px'
  },
  link: {
    textDecoration: 'none'
  },
  icon: {
    marginRight: 10, fontSize: 80
  },
  // },
  Containers: {
    DefaultStyle: {
      width: 500,
      position: 'fixed',
      top: '45vh'
    },
    tc: {
      marginLeft: -(500 / 2)
    }
  },
  Title: {
    DefaultStyle: {
      fontWeight: 'normal',
      textAlign: 'center',
      color: 'white',
      fontSize: '1rem'
    }
  },
  Dismiss: {
    success: {
      color: '#11680C',
      backgroundColor: 'rgba(0,0,0,0)',
      fontSize: '1rem'
    },
    error: {
      color: ' #99042E',
      backgroundColor: 'rgba(0,0,0,0)',
      fontSize: '1rem'
    }
  }
}

const ConnectedClaimReceipts = connect(mapStateToProps, { push })(injectIntl(ClaimReceipts))

export default withStyles(styles)(ConnectedClaimReceipts)



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimReceipts.js